import { render, staticRenderFns } from "./Genealogy.vue?vue&type=template&id=1ec236bc&"
import script from "./Genealogy.vue?vue&type=script&lang=js&"
export * from "./Genealogy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports